module.exports = __webpack_public_path__ + "static/media/excel.a7d14b65.svg";